<div id="content" class="allcp-form" ng-controller="EarningController" ng-init="all()">
    <div ng-include="'modules/company/menus/order_menu.html'"></div>

    <div class="navbar fixed-panel-footer" ng-if="deleted.length">
        <div class="nav navbar-nav navbar-left">
            <a href="#" ng-click="selectAll(true)" class="btn mr-2 btn-outline">Select All</a>
            <a href="#" ng-click="selectAll(false)" class="btn btn-outline">Unselect</a>
        </div>
        <div class="nav navbar-nav navbar-center">
        </div>
        <div class="nav navbar-nav navbar-right">
            <a href="#"
                ng-click="delete('set')" 
                ng-disabled="deleted.length == 0" 
                ng-if="deleted.length > 0"
                class="btn btn-danger btn-rounded mr-3">Delete</a>
        </div>
    </div>

    <div class="panel-body">
        <div class="row mb-4" ng-if="filterData.summary">
            <div class="col-md-3">
                <div class="panel panel-tile border-chart text-center">
                    <div class="m-4">
                        <h3 class="mbn mtn text-dark">{{ data.count.total?data.count.total:0 | currency }} </h3>
                        <strong>Total</strong>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="panel panel-tile border-chart text-center">
                    <div class="m-4">
                        <h3 class="mbn mtn text-dark">{{ data.count.paid?data.count.paid:0 | currency }} </h3>
                        <strong>Paid</strong>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="panel panel-tile border-chart text-center">
                    <div class="m-4">
                        <h3 class="mbn mtn text-dark">{{ data.count.open?data.count.open:0 | currency }} </h3>
                        <strong>Open</strong>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="panel panel-tile border-chart text-center">
                    <div class="m-4">
                        <h3 class="mbn mtn text-dark">{{ data.count.total_tip?data.count.total_tip:0 | currency }} </h3>
                        <strong>Total Tip</strong>
                    </div>
                </div>
            </div>
        </div>

        <div class="table-responsive" ng-if="data.earnings.data.length > 0">
            <table class="table table-hover tc-checkbox-1 fs13">
                <thead>
                    <tr class="bg-light">
                        <th>
                        </th>
                        <th style="min-width: 120px;">Earning ID</th>
                        <th style="min-width: 100px;">Worker</th>
                        <th style="min-width: 100px;">Date</th>
                        <th style="min-width: 90px;">Total</th>
                        <th style="min-width: 60px;">Balance Due</th>
                        <th style="min-width: 90px;">Paid</th>
                        <th style="min-width: 120px;">
                            Status
                            <a ng-click="sort('status','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('status','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr 
                        dir-paginate="item in data.earnings.data | itemsPerPage: 30" 
                        total-items="data.earnings.total" 
                        current-page="data.earnings.current_page">
                        <td class="text-center">
                            <label class="option block mn">
                                <input type="checkbox" name="deleted[]" ng-checked="deleted.indexOf(item.id) > -1" ng-click="toggleSelection(item.id)">
                                <span class="checkbox mn"></span>
                            </label>
                        </td>
                        <!-- <td class="clickable-row">
                            <label class="option block mn" ng-if="item.status == 0 || item.status == null">
                                <input type="checkbox" ng-click="checkBilling(item.id)" ng-checked="selectedItems.indexOf(item.id) !== -1" id="checkboxDefault-{{item.id}}">
                                <span class="checkbox mn"></span>
                            </label>
                        </td> -->
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.unique }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.worker.full_name }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">{{ item.date | amDateFormat:'MM/DD/YYYY' }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">${{ item.total_price | number:2 }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">${{ Number(item.balance_due) | number:2 }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">${{ item.paid | number:2 }}</td>
                        <td class="clickable-row" ng-click="openDetail(item)">
                            <span ng-if="!item.status">Open</span>
                            <span ng-if="item.status" style="color: rgb(43, 191, 201);">Paid</span>
                        </td>
                        <td class="text-right pr20">
                            <a 
                                href="/orders?route_optimization_id={{ item.route_optimization_id }}"
                                target="__BLANK"
                                class="btn btn-outline btn-file">
                                Show Completed Orders</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <dir-pagination-controls 
                boundary-links="true" 
                on-page-change="getPage(newPageNumber)" 
                template-url="dirPagination.tpl.html"
                class="pagination-lg pagination pull-right pr10">
            </dir-pagination-controls>
        </div>
        <div class="text-center mt50" ng-if="data.earnings.data.length == 0">
            <img src="img/empty_page_orange.svg" alt="" width="400px">
            <br>
            <h3 style="font-size: 48px;font-weight: 800;">Earning not found</h3>
        </div>
    </div>
    <div ng-include="'modules/company/earning/show.html'"></div> 
    <div ng-include="'modules/company/earning/new.html'"></div>
    <div ng-include="'modules/company/earning/new-payment.html'"></div>
    <div ng-include="'modules/company/settings/partials/delete.html'"></div>
</div>